/** Minutes as "Xh Ym", used by the late, early-exit and OT flags. */
export const formatHoursMinutes = (minutes: number = 0) =>
  `${Math.floor(minutes / 60)}h ${minutes % 60}m`;
